var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('BreadcrumbsInline',{staticClass:"hidden-sm-and-down",attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('BreadcrumbsDropdown',{staticClass:"hidden-md-and-up",attrs:{"breadcrumbs":_vm.breadcrumbs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }